export const yesNoOptions = ({ t }) => [
  { name: t('common.no', 'NIE'), value: 0 },
  { name: t('common.yes', 'TAK'), value: 1 },
];
